<template>
  <w-modal
    v-model="show"
    class="modal-big"
    submit-button="Zamknij"
    title="Przyciski statusu"
    :show-close-button="false"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @close="close"
    @submit="close"
  >
    <div class="row">
      <div v-for="(button, index) in buttons" :key="'button_' + index" class="col-md-12">
        <button-form
          :button="button"
          @cancel="cancel(button, index)"
          @edit="edit(button)"
          @remove="remove(button, index)"
          @save="save(index, button, $event)"
        />
      </div>
    </div>

    <div v-if="!editing" class="mt-2">
      <w-button class="btn-primary float-right" icon="fas fa-plus" text="Dodaj" @click="add" />
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import ButtonForm from '@/components/forms/ButtonForm';
import { Errors } from '@/enums/errors.enum';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Modal dodania statusu
// @group Status
export default {
  components: { ButtonForm },
  mixins: [modalMixin, notificationsMixin],
  props: {
    // Identyfikator statusu
    statusId: { type: Number }
  },
  computed: {
    ...mapState({ buttons: state => state.button.list }),
    editing() {
      return this.buttons.some(button => !!button.edit);
    }
  },
  methods: {
    // @vuese
    // Otwiera formularz dodawania przycisku
    add() {
      if (!this.editing) {
        this.buttons.push({ edit: true, roleIds: [5], statusId: this.statusId });
      }
    },

    // @vuese
    // Anuluje edycję / dodawanie
    cancel(button, index) {
      if (button.id) {
        button.edit = false;
      } else {
        this.buttons.pop();
      }
    },

    // @vuese
    // Otwiera formularz edycji przycisku
    edit(button) {
      if (!this.editing) {
        this.$set(button, 'edit', true);
      }
    },

    // @vuese
    // Usuwa przycisk
    remove(button, index) {
      this.$store
        .dispatch(`button/remove`, button.id)
        .then(() => this.buttons.splice(index, 1))
        .catch(err => this.notifyError(Errors.BUTTON_CANNOT_REMOVE));
    },

    // @vuese
    // Zapisuje przycisk
    save(index, button, data) {
      const action = button.id ? 'update' : 'add';
      this.$store
        .dispatch(`button/${action}`, {
          ...data,
          id: button.id,
          actionData: data.action ? JSON.parse(data.actionData) : undefined
        })
        .then(id => {
          if (!button.id) {
            this.buttons.pop();
          }
        })
        .catch(err => this.notifyError(Errors.BUTTON_CANNOT_SAVE));
    }
  }
};
</script>
